import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Link,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from '@chakra-ui/core';
import moment from 'moment';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import TwitterIcon from '.././assets/twitter_bird.svg';
import { toBTC } from '../utils/Utils';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from './Table/Table';
import { ELECTION_RESOLUTION_DATE } from '../utils/Election';

const TableEmptyState = ({ label }) => (
  <Flex alignItems="center" justifyContent="center" bg="#F6F6F6" h="200px">
    <Heading fontWeight={500} size="md" color="#7c7c7c">
      {label}
    </Heading>
  </Flex>
);

const EmptyOffersState = ({ twitterInfo }) => (
  <Flex
    alignItems="center"
    justifyContent="center"
    bg="#F6F6F6"
    h="200px"
    flexDir="column"
  >
    <Heading fontWeight={500} size="md" color="#7c7c7c">
      All the bets from {twitterInfo.name} are taken
    </Heading>

    <Heading fontWeight={500} size="sm" color="#7c7c7c" mt={4}>
      Tweet at them to add more bets
      <Link
        href={`https://twitter.com/intent/tweet?screen_name=${twitterInfo.screen_name}&url=https%3A%2F%2Fatomic.finance%2Fodds%2Fapp%2Finfluencer%2F${twitterInfo.screen_name}&text=You%27re%20out%20of%20offers%20on%20@AtomicFinance%21%20Put%20your%20bitcoin%20where%20your%20mouth%20is%20and%20place%20some%20more`}
        target="_blank"
        position="relative"
        height="20px"
        fontSize="12px"
        padding="4px 8px 4px 6px"
        backgroundColor="#1b95e0"
        color="#fff"
        ml={2}
        borderRadius="3px"
        fontWeight="500"
        cursor="pointer"
      >
        <Image src={TwitterIcon} display="inherit" height="12px" mr="1px" />
        Tweet @{twitterInfo.screen_name}
      </Link>
    </Heading>
  </Flex>
);

const OfferRow = ({ offer }) => {
  const {
    contractId,
    betDetails: {
      prediction,
      betAmountCounter,
      resolutionDate,
      betSize,
      betAmount,
    },
  } = offer;

  return (
    <TableRow bg="white">
      <TableCell>
        <Text fontSize="sm">Presidential Election</Text>
      </TableCell>
      <TableCell>
        <Text fontSize="sm" textTransform="capitalize">
          {prediction}
        </Text>
      </TableCell>
      <TableCell>
        <Text fontSize="sm">{toBTC(betAmount)} BTC</Text>
      </TableCell>
      <TableCell>
        <Text fontSize="sm">
          1 : {parseFloat((betAmountCounter / betAmount).toFixed(1))}
        </Text>
      </TableCell>
      <TableCell>
        <Text fontSize="sm">{toBTC(betSize)} BTC</Text>
      </TableCell>
      <TableCell>
        <Text fontSize="sm">{moment((new Date(resolutionDate)).toISOString() === ELECTION_RESOLUTION_DATE.toISOString() ? new Date('2020-11-04T02:00:00.000Z') : resolutionDate).fromNow()}</Text>
      </TableCell>

      <TableCell>
        <Link
          as={RouterLink}
          fontSize="sm"
          color="blue.600"
          fontWeight="bold"
          to={`/offer/${contractId}`}
        >
          View Offer
        </Link>
      </TableCell>
    </TableRow>
  );
};

const PastOfferRow = ({ offer }) => {
  const {
    betDetails: { prediction, betAmountCounter, betSize, betAmount },
  } = offer;

  return (
    <TableRow bg="white">
      <TableCell>
        <Text fontSize="sm">Presidential Election</Text>
      </TableCell>
      <TableCell>
        <Text fontSize="sm" textTransform="capitalize">
          {prediction}
        </Text>
      </TableCell>
      <TableCell>
        <Text fontSize="sm">{toBTC(betAmount)} BTC</Text>
      </TableCell>
      <TableCell>
        <Text fontSize="sm">
          1 : {parseFloat((betAmountCounter / betAmount).toFixed(1))}
        </Text>
      </TableCell>
      <TableCell>
        <Text fontSize="sm">{toBTC(betSize)} BTC</Text>
      </TableCell>
    </TableRow>
  );
};

const ViewOffers = ({ offers, pastOffers, twitterInfo }) => {
  return (
    <Box
      bg="white"
      h="fit-content"
      w="100%"
      borderRadius="4px"
      gridArea="bets"
      p={4}
    >
      <Tabs size="sm" isLazy variant="unstyled">
        <TabList mb={4}>
          <Tab
            border="solid 1px #32325d"
            borderRadius="4px 0 0 4px"
            _selected={{ bg: '#32325d', color: 'white' }}
          >
            Active Offers ({offers.length})
          </Tab>
          <Tab
            borderRadius="0 4px 4px 0"
            border="solid 1px #32325d"
            _selected={{ bg: '#32325d', color: 'white' }}
          >
            Past Offers ({pastOffers.length})
          </Tab>

          <Box ml="auto">
            <RouterLink to="/new">
              <Button size="sm" colorScheme="blue">
                Don't like the odds? Create your own bet
              </Button>
            </RouterLink>
          </Box>
        </TabList>

        <TabPanels>
          <TabPanel padding={0}>
            {offers.length === 0 ? (
              <EmptyOffersState twitterInfo={twitterInfo} />
            ) : (
              <Box>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableHeader>Bet Type</TableHeader>
                      <TableHeader>Their Prediction</TableHeader>
                      <TableHeader>Their Bet Amount</TableHeader>
                      <TableHeader>Bet Odds</TableHeader>
                      <TableHeader>Total Payout</TableHeader>
                      <TableHeader>Offer Expires</TableHeader>
                      <TableHeader />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {offers.map((offer) => (
                      <OfferRow offer={offer} />
                    ))}
                  </TableBody>
                </Table>
              </Box>
            )}
          </TabPanel>
          <TabPanel padding={0}>
            {pastOffers.length === 0 ? (
              <TableEmptyState label="No Past Offers" />
            ) : (
              <Box>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableHeader>Bet Type</TableHeader>
                      <TableHeader>Their Prediction</TableHeader>
                      <TableHeader>Their Bet Amount</TableHeader>
                      <TableHeader>Bet Odds</TableHeader>
                      <TableHeader>Total Payout</TableHeader>
                      <TableHeader />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {pastOffers.map((offer) => (
                      <PastOfferRow offer={offer} />
                    ))}
                  </TableBody>
                </Table>
              </Box>
            )}
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default ViewOffers;
